import calc from 'calculatorjs'

const state = {
  createForm: null,
  createPrepare: null,
  currCoupon: null,
}

const getters = {
  shippingRatesInfo (state, getters, rootState) {
    if (!state.createPrepare) return null
    return state.createPrepare.shippingRates.find(item => item.srid === state.createForm.spgrSrid)
  },
  totalAmount (state, getters, rootState) {
    let amount = 0
    if (getters.shippingRatesInfo) {
      amount = getters.shippingRatesInfo.parcelsFeeInclTax
    }
    if (state.currCoupon) {
      amount -= state.currCoupon.discountInfo.discount
    }
    return amount
  },
  schedules (state, getters, rootState) {
    const shippingRatesInfo = getters.shippingRatesInfo
    if (!shippingRatesInfo) return []
    if (shippingRatesInfo.transport === 'se') {
      let list = state.createPrepare.schedulesSe
      if (shippingRatesInfo.srLabel === 'HZKZQ' || shippingRatesInfo.srLabel === 'HZKHD') {
        list = state.createPrepare.schedulesHzk.filter(item => {
          if (shippingRatesInfo.srLabel === 'HZKZQ' && shippingRatesInfo.addrid === '1592') {
            return item.calendars.find(c => c.calTag === '台中清關' || c.calTag === '高雄清關')
          }
          return true
        })
      }
      return list.filter(item => item.calendars.length).map(item => {
        const calendar = item.calendars.find(item => item.calEvent.indexOf('船期') > -1)
        return {
          cut: calendar.calJycutAt,
          boardAt: calendar.calDatetime,
          delivery: calendar.calDelivAt,
        }
      })
    } else if (shippingRatesInfo.transport === 'air') {
      return Object.values(state.createPrepare.schedulesAir).map(item => {
        return {
          cut: item.schedule.cut,
          boardAt: item.schedule.cut,
          delivery: item.schedule.delivery,
        }
      })
    }

    return []
  }
}

const mutations = {
  setCreateForm (state, createForm) {
    state.createForm = createForm
  },
  setCreatePrepare (state, createPrepare) {
    state.createPrepare = createPrepare
  },
  initCreateForm (state, form) {
    state.currCoupon = null
    state.createForm = {
      spgrReceiveType: '', // 收件方式
      spgrReceiveRemark: '', // 收件備註
      spgrCity: '', // 城市
      spgrDistrict: '', // 地區
      spgrCneeAddrid: '', // 收件地址
      spgrCoinPerKg: '', // 每KG收取金巧幣
      spgrExpectWeight: '', // 預計拼團重量
      spgrCutAt: '', // 截單時間
      spgrBrief: '', // 拼團說明
      pclids: [],
      spgrSrid: '', // 運費id
      spgrJyoShpMethod: '1', // 出貨方式
      spgrCrid: '', // 优惠券id
      payPwd: '', // 支付密碼
      spgrExtras: {
        selfAddrid: [],
      },
    }
  },
  setCurrCoupon (state, currCoupon) {
    state.currCoupon = currCoupon
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
  }
}
